<cxone-modal #modal [headerTitle]="modalTitle" (closed)="save()" (dismissed)="cancel()" [allowClose]="true" [focusOnShow]="true">
    <div id="CategorySelectionModal" class="content">
        <div id="SelectorTypeBar" *ngIf="hasAutoSelect">
            <div class="d-flex flex-column">
                <div class="selectorControl">
                    <input type="radio" id="automaticCategorySelection" (click)="resize(false)" [(ngModel)]="manualSelect" [value]="false" />
                    <label for="automaticCategorySelection">Automatically</label>
                </div>
                <span class="selectorContext">Show category with highest volume of interactions in selected time range</span>
            </div>
            <div>
                <div class="selectorControl">
                    <input type="radio" id="manualCategorySelection" (click)="resize(true)" [(ngModel)]="manualSelect" [value]="true" />
                    <label for="manualCategorySelection">Manually</label>
                </div>
            </div>
        </div>
        <app-module-error class="flex-fill" *ngIf="noData && manualSelect" [noData]="true"></app-module-error>
        <div id="TreeArea" *ngIf="(!hasAutoSelect || manualSelect) && !noData">
            <cxone-omnibar [itemCountLabel]="itemCountLabel" [searchPlaceholderText]="searchPlaceholderText"
                           (searchQueryChange)="filterChanged($event)" [isFilterable]="false">
                <cxone-omnibar-custom-content class="lang-wrapper">
                    <cxone-singleselect-dropdown [(ngModel)]="selectedLang" [options]="langOptions" [label]="'name'" [primaryKey]="'keId'" [showFooter]="false"
                                                 [isLoading]="" [isRequired]="false" [search]="false" customOmnibar="true" (ngModelChange)="loadData()"
                                                 [maxItemsToDisplay]="1000"></cxone-singleselect-dropdown>
                </cxone-omnibar-custom-content>
            </cxone-omnibar>
            <div style="height: 200px">
                <ag-grid-angular #categorySelectionModalGrid id="CSMGrid" class="ag-theme-balham w-100" [gridOptions]="gridOptions"></ag-grid-angular>
            </div>
        </div>
    </div>
</cxone-modal>
